import React, { Component } from 'react';
import { Checkbox, FormGroup, FormControlLabel } from '@material-ui/core';

class CheckboxField extends Component {
	constructor(props) {
		super(props)
		this.state = {
			className: this.props.className,
			classNameJS: this.props.classNameJS,
			isRequired: this.props.isRequired,
			options: this.props.options,
			buttonID: this.props.buttonID,
			onChange: this.props.onChange,
			saveResponse: this.props.saveResponse,
			inputName: this.props.inputName,
			showIcon: this.props.showIcon,
			isSelected: false
		}
		this.handleChange = this.handleChange.bind(this)
	}

	handleChange(event) {
		let isOptionSelected = event.target.closest('.ca-checkbox-field__option').classList.contains('ca-checkbox-field__option--selected');
		isOptionSelected ? event.target.closest('.ca-checkbox-field__option').classList.remove('ca-checkbox-field__option--selected') : event.target.closest('.ca-checkbox-field__option').classList.add('ca-checkbox-field__option--selected');

		this.state.onChange(event);
	}

	render() {
		const createClassList = () => {
			let classList = 'ca-checkbox-field';
			if (this.state.showIcon) classList = classList + ' ca-checkbox-field--icon';
			if (this.state.className) classList = classList + ' ca-checkbox-field--' + this.state.className;
			if (this.state.classNameJS) classList = classList + ' ' + this.state.classNameJS;
			if (this.state.isRequired) classList = classList + ' js-required';

			return classList;
		};
	
		const checkboxOptions = this.state.options.map((option, index) => (
			<span className='ca-checkbox-field__option' key={index}>
				<FormControlLabel control={(
					<>
						{this.state.showIcon ? <img src={require(`../../images/icons/${option.icon.name}`)} alt={option.icon.altText} /> : null}
						<Checkbox value={option.value} onChange={this.handleChange} />
					</>	
				)} label={option.label ? option.label : option.value} />
			</span>
		));
	
		return (
			<div className={createClassList()} data-button-id={this.state.buttonID} data-save={this.state.saveResponse} data-name={this.state.inputName}>
				<FormGroup>
					{checkboxOptions}
				</FormGroup>
			</div>
		);
	}
}

export default CheckboxField;

